const ValidateEmail = (email) => {
  if (/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(String(email).trim())) {
    return true;
  } else {
    return false;
  }
};
export default ValidateEmail;
